// @flow

import type { ReportingParametersState } from "./types";

export const initialState: ReportingParametersState = {
  error: null,
  requestsInProgress: 0,
  data: {
    absenceRateCalculationType: "",
    autoDisabling: 0,
    bradfordScore: false,
    bradfordScoreAbsenceType: "",
    bradfordScoreDayType: "",
    bradfordScorePeriod: 0,
    bv12Trend: false,
    changeSetState: "",
    descriptionReasonCostAbsence: "",
    descriptionReasonSuspectedUnderReporting: "",
    employeeAbsenceRates: false,
    estimatedDailyAbsenceCost: 0,
    historicalDataUnderReporting: 0,
    isLocked: false,
    longTermDefinitionDays: 0,
    longTermDefinitionType: "",
    reportingPeriods: "",
    reportsExpiry: 0,
    rtwIncludedAbsenceRates: false,
    salaryCostAbsenceTrend: false,
    scheduledReportAccess: [],
    scheduledReportsEnabled: false,
    selfServiceEnabled: false,
    targetAbsenceRate: 0,
  },
  reasonsToBeExcluded: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
      totalPages: 0,
    },
    totalElements: 0,
  },
  modals: {
    reasonsToBeExcluded: {
      visible: false,
    },
    reportingParameters: {
      visible: false,
    },
    deleteReasonToBeExcludedConfirm: {
      visible: false,
    },
    scheduledReports: {
      visible: false,
    },
    scheduledReportsWarning: {
      visible: false,
    },
  },
};

export default initialState;
